<div class="pto-project-cards-main-container">
  <div class="pto-project-cards-filters-container">
    <span class="projects-title">Projects</span>
    <p-button styleClass="sort-by-btn" (click)="op.toggle($event)">
      <img alt="logo" src="../../../../../assets/icons/projects-overview/sort_by_icon.svg"/>
      <span>Sort by</span>
    </p-button>
    <p-overlayPanel #op styleClass="pto-sort-by-overlay">
      <ng-template pTemplate>
        <div class="filter-option" *ngFor="let radio of radioButtons">
          <label class="d-flex gap-2 mb-0">
            <p-radioButton
              (onClick)="setFilterByScore()"
              [name]="'sort-by'" id="{{radio.id}}"
              [value]="radio"
              [(ngModel)]="selectedRadioButton">
            </p-radioButton>
            <span>{{radio.label}}</span>
          </label>
        </div>
      </ng-template>
    </p-overlayPanel>
    <div class="pto-indicators-dropdown">
      <span class="selected-indicator-label">{{'projects_overview_selected_indicator' | translate}}</span>
      <p-dropdown
        [options]="projectDefaultCategories"
        [(ngModel)]="selectedIndicator"
        optionLabel="title"
        placeholder="Project health indicators"
        (onChange)="changeIndicator($event.value)"
        dropdownIcon="bi bi-caret-down-fill"        
        dataKey="uuid">
      </p-dropdown>
    </div>
  </div>
  <div class="pto-cards-container">
    <div #projectCard
      class="pto-card" *ngFor="let card of projectCards"
      [ngClass]="(selectedProjectCard && selectedProjectCard?.project.uuid === card.project.uuid) ? 'highlight-card' : 'animation'"
      appClickOutside
      (appClickOutside)="closeQuickActionsMenu()"
      (pointerdown)="openQuickActionsMenu(card, projectCard);$event.stopPropagation()">
      <div class="pto-card-labels">
        <div class="project-type-container">
          <span>{{card.project.projectType | uppercase}}</span>
        </div>
        <div *ngIf="card.project.newProject || card.project.isPaused" class="labels-container">
            <div *ngIf="card.project.newProject" class="new-project-label" pTooltip="{{'to_new_team_label_tooltip'|translate}}" tooltipPosition="bottom" tooltipStyleClass="response-distribution-tooltip">{{'to_new_team_label' | translate}}</div>
            <div *ngIf="card.project.isPaused" class="warning-label" pTooltip="{{'projects_overview_paused_project_warning'|translate}}" tooltipPosition="bottom" tooltipStyleClass="member-email-tooltip">
                <img class="warning-label-icon" src="../../../../../assets/svg/warning-label-icon.svg" alt="warning">
            </div>
        </div>
      </div>
      <span class="project-name">{{card.project.name}}</span>
      <div [ngClass]="{'indicator-selected' : selectedIndicator}" class="project-health-container"
           [ngStyle]="{'background-color':!selectedIndicator ?
                                           card.project.fadeColor :
                                           card?.indicators[selectedIndicator?.index]?.fadeColor}">
        <div [ngClass]="{'indicator-selected' : selectedIndicator}" class="project-health-title-and-rate">
          <app-dinamic-indicator-display *ngIf="selectedIndicator"
            [indicatorName]="selectedIndicator.slug" [color]="card?.indicators[selectedIndicator?.index]?.color"></app-dinamic-indicator-display>
          <span class="health-title mb-auto">{{ !selectedIndicator ? 'Project Health' : selectedIndicator.title }}</span>
        </div>
        <app-gauge-display *ngIf="!selectedIndicator"
          [value]="card.score ?? 0"
          [width]="125"
          [height]="100"
          [trend]="null"
          [colorStart]="card.project.color"
          [colorEnd]="card.project.color"
          [backgroundColor]="'rgba(255, 255, 255, 1)'"
          [isOnProjectTeam]="false"
          [isOnTeamCodex]="false">
        </app-gauge-display>
        <div class="indicator-value-con" *ngIf="selectedIndicator">
          <span class="indicator-value-text">{{card?.indicators[selectedIndicator?.index]?.score ?? 0}}</span>
          <span class="indicator-percent">%</span>
        </div>
      </div>
      <div class="pto-card-manager-container">
        <span class="pto-card-manager-title">Project Manager:</span>
        <div class="d-flex align-items-center gap-2">
          <img class="manager-avatar"
               [src]="(card.project.leader.user?.avatar !== null && card.project.leader.user.avatar?.path !== null) ?
                       baseUrl + card.project.leader.user.avatar?.path: '../../../assets/svg/user-icon.svg'"
               alt="icon">
          <span class="manager-name">
            {{card.project.leader.user.detail.displayName ?
              card.project.leader.user.detail.displayName :
              (card.project.leader.user.detail.firstname ||
                card.project.leader.user.detail.lastname) ?
                card.project.leader.user.detail.firstname+' '+card.project.leader.user.detail.lastname :
                card.project.leader.user.email}}
          </span>
        </div>
      </div>
      <app-quick-actions-menu class="app-quick-actions-menu"
      [ngClass]="{
        'open-left' : cardPositions.shouldOpenLeft,
        'open-from-bottom' : cardPositions.bottomScroll,
        'open-from-middle' : cardPositions.middleScroll,
        'loading-on' : !quickActionData
      }" 
      (pointerdown)="$event.stopPropagation();" 
      *ngIf="(selectedProjectCard && selectedProjectCard?.project.uuid === card.project.uuid)"
        [cardData]="this.selectedProjectCard"
        [quickActionData]="quickActionData"
        [cardPositions]="cardPositions"
        (emitPauseOrResumeProject)="pauseOrResumeProject($event)"
        (emitGoToDashboard)="goToProjectDashboard()"
        (emitCloseMenu)="closeQuickActionsMenu()"
      ></app-quick-actions-menu>
    </div>
  </div>
</div>
